import LengkapiNoHpNota from "./LengkapiNoHpNota";
import useBolehLengkapiNoHp from "../../hooks/useBolehLengkapiNoHp";

/** Bagian "No HP nota belum sah" di dua layar pengajuan retur tukar unit (modal
 *  Ajukan Retur di Penjualan, menu Ajukan Retur Penjualan di halaman Retur).
 *
 *  Jawaban owner 29b (24 Sep 2026; Head Store ikut sejak 25 Sep): yang boleh
 *  melengkapi No HP nota lama hanya Head Store, SPV, dan jabatan di atasnya —
 *  BUKAN approver retur (`bisaKelolaRetur`), yang
 *  memuat admin ber-jabatan staf dan pemegang izin retur.update. Keputusan
 *  tampil form / petunjuk / galat dipusatkan di sini supaya kedua layar tidak
 *  bisa berpisah jalan; halaman cukup merender komponen ini saat nota perlu No HP.
 *
 *  `prefix` = awalan data-testid, sama dengan LengkapiNoHpNota. */
export default function GerbangLengkapiNoHp({ saleId, prefix, onSelesai }) {
  const { boleh, ulangi } = useBolehLengkapiNoHp(saleId);
  if (boleh === true) {
    return <LengkapiNoHpNota saleId={saleId} prefix={prefix} onSelesai={onSelesai} />;
  }
  if (boleh === false) {
    return (
      <p className="text-[11px] text-amber-800 mt-1" data-testid={`${prefix}-minta-spv`}>
        Minta Head Store / SPV (atau jabatan di atasnya) melengkapi No HP nota ini.
      </p>
    );
  }
  if (boleh === "galat") {
    return (
      <p className="text-[11px] text-rose-700 mt-1" data-testid={`${prefix}-wewenang-galat`}>
        Gagal memeriksa siapa yang boleh melengkapi No HP nota ini.{" "}
        <button type="button" onClick={ulangi} data-testid={`${prefix}-wewenang-ulang`}
          className="underline font-medium">
          Coba lagi
        </button>
      </p>
    );
  }
  return null;
}
